export async function documentReady() {
  return new Promise<void>((resolve) => {
    function handleDOMContentLoaded() {
      document.removeEventListener('DOMContentLoaded', handleDOMContentLoaded);
      resolve();
    }

    if (['interactive', 'complete'].includes(document.readyState)) {
      resolve();
    } else {
      document.addEventListener('DOMContentLoaded', handleDOMContentLoaded);
    }
  });
}
